import styled from "styled-components";

export const TextName = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: initial;

    span{
        color: var(--input-font-color);
        font-size:0.8rem;
    }
`;

export const Container = styled.div``;
